import Http from '@/services/httpAcademy'

// ── Assessments ────────────────────────────────────────────────────────────────
export const listAssessments    = (params) => Http.get('/admin/assessments', { params })
export const getAssessment      = (id)     => Http.get(`/admin/assessments/${id}`)
export const createAssessment   = (data)   => Http.post('/admin/assessments', data)
export const updateAssessment   = (id, data) => Http.put(`/admin/assessments/${id}`, data)
export const deleteAssessment   = (id)     => Http.delete(`/admin/assessments/${id}`)
export const publishAssessment  = (id)     => Http.post(`/admin/assessments/${id}/publish`)
export const generateAiAssessment = (data) => Http.post('/admin/assessments/generate-ai', data)
export const approveAiAssessment  = (id)   => Http.post(`/admin/assessments/${id}/approve-ai`)
export const rejectAiAssessment   = (id, reason) => Http.post(`/admin/assessments/${id}/reject-ai`, { reason })

// ── Questions ─────────────────────────────────────────────────────────────────
// Questions are authored inline via the admin store/update payload
// (`questions` array). These endpoints remain available for the company
// flow where the recruiter adds/removes questions after the assessment has
// been created.
export const storeQuestion   = (assessmentId, data) => Http.post(`/company/assessments/${assessmentId}/questions`, data)
export const updateQuestion  = (assessmentId, questionId, data) => Http.put(`/company/assessments/${assessmentId}/questions/${questionId}`, data)
export const deleteQuestion  = (assessmentId, questionId) => Http.delete(`/company/assessments/${assessmentId}/questions/${questionId}`)

// ── Categories ────────────────────────────────────────────────────────────────
// Category read endpoints live under /public/; admin-only mutations under /admin/.
export const listCategories   = (params) => Http.get('/public/assessments/categories', { params })
export const getCategory      = (id)     => Http.get(`/public/assessments/categories/${id}`)
export const createCategory   = (data)   => Http.post('/admin/assessment-categories', data)
export const updateCategory   = (id, data) => Http.put(`/admin/assessment-categories/${id}`, data)
export const deleteCategory   = (id)     => Http.delete(`/admin/assessment-categories/${id}`)

// ── Stats ─────────────────────────────────────────────────────────────────────
export const fetchAssessmentStats        = ()       => Http.get('/admin/assessments/stats')
export const fetchCareerTrailStats       = ()       => Http.get('/admin/career-trails/stats')

// ── Certifications ────────────────────────────────────────────────────────────
export const listCertifications          = (params) => Http.get('/admin/skill-certifications', { params })
export const issueAssessmentCertificate  = (data)   => Http.post('/admin/assessments/issue-certificate', data)
export const searchAssessmentResults     = (params) => Http.get('/admin/assessments/search-results', { params })

// ── Live Activity ─────────────────────────────────────────────────────────────
export const listAssessmentActivity  = (params) => Http.get('/admin/assessments/activity', { params })
export const listCareerTrailActivity = (params) => Http.get('/admin/career-trails/activity', { params })

// ── Career Trails ─────────────────────────────────────────────────────────────
export const issueTrailCertificate = (data) => Http.post('/admin/career-trails/issue-certificate', data)
export const listCareerTrails    = (params) => Http.get('/admin/career-trails', { params })
export const getCareerTrail      = (id)     => Http.get(`/admin/career-trails/${id}`)
export const createCareerTrail   = (data)   => Http.post('/admin/career-trails', data)
export const updateCareerTrail   = (id, data) => Http.put(`/admin/career-trails/${id}`, data)
export const deleteCareerTrail   = (id)     => Http.delete(`/admin/career-trails/${id}`)
export const storeTrailLevel     = (trailId, data) => Http.post(`/admin/career-trails/${trailId}/levels`, data)
export const updateTrailLevel    = (trailId, levelId, data) => Http.put(`/admin/career-trails/${trailId}/levels/${levelId}`, data)
export const deleteTrailLevel    = (trailId, levelId) => Http.delete(`/admin/career-trails/${trailId}/levels/${levelId}`)
export const storeTrailStep      = (trailId, levelId, data) => Http.post(`/admin/career-trails/${trailId}/levels/${levelId}/steps`, data)
export const updateTrailStep     = (trailId, levelId, stepId, data) => Http.put(`/admin/career-trails/${trailId}/levels/${levelId}/steps/${stepId}`, data)
export const deleteTrailStep     = (trailId, levelId, stepId) => Http.delete(`/admin/career-trails/${trailId}/levels/${levelId}/steps/${stepId}`)
export const uploadCareerTrailThumbnail = (id, formData) =>
	Http.post(`/admin/career-trails/${id}/thumbnail`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})
